import { useMemo } from 'react';
import { debounce } from './debounce.js';

const useDebounce = (callback, waitMS) => {
    return useMemo(() => debounce(callback, waitMS), [waitMS, callback]);
};

export { useDebounce };
//# sourceMappingURL=useDebounce.js.map
